<ng-container *transloco="let t">
  <div 
    class="qr-modal-overlay" 
    *ngIf="isVisible"
    [@modalOverlay]
    (click)="onModalBackdropClick()"
    (keydown.escape)="onCloseModal()">
    
    <div 
      class="qr-modal-content" 
      [@modalContent]
      (click)="onModalContentClick($event)">
      
      <button 
        class="close-button" 
        (click)="onCloseModal()"
        [attr.aria-label]="'Close QR Code Modal'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      
      <div class="qr-header">
        <div class="store-logo">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" *ngIf="activeStore === 'appstore'">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"></path>
          </svg>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" *ngIf="activeStore === 'playstore'">
            <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35l13.69 8.5-13.69 8.5c-.5-.24-.84-.76-.84-1.35zm13.81-5.38L6.05 21.07l8.49-8.49 2.27 2.54zm0-6.24l-2.27 2.54-8.49-8.49L16.81 8.88zm2.58.82l-2.31 1.43-2.31-2.59L19.39 9.7z"></path>
          </svg>
        </div>
        
        <div class="store-info">
          <h3 class="modal-title">{{ getModalTitle() }}</h3>
          <p class="modal-subtitle">{{ t(translationScope + '.subtitle') }}</p>
        </div>
      </div>
      
      <div class="qr-body">
        <div class="qr-container">
          <div class="qr-frame">
            <img 
              [src]="getQRCodeUrl()" 
              [alt]="'QR Code for ' + getStoreName()"
              class="qr-image"
              (error)="onQRImageError($event)">
          </div>
          
          <div class="qr-pulse-ring"></div>
        </div>
      </div>
      
      <div class="qr-footer">
        <button 
          class="direct-link-button" 
          (click)="onDirectLinkClick()"
          [attr.aria-label]="'Open direct link to ' + getStoreName()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
          </svg>
          {{ t(translationScope + '.directLink') }}
        </button>
      </div>
    </div>
  </div>
</ng-container> 